<template>
  <v-modal
    @hide-modal="$emit('hide-modal')"
    size="md"
  >
    <template v-slot:title>
      <h4>{{ $t('sentence.send_mail_to_users', { userCount }) }}</h4>
    </template>
    <template v-slot:body>
      <div v-show="showConfirmMessage" class="pt-2">
        <h5>{{ formData.subject }}</h5>
        <div v-html="formData.body"></div>
      </div>
      <div v-show="!showConfirmMessage">
        <div class="mb-3">
          <v-text-input
            v-model="formData.subject"
            :errors="errors.subject"
            placeholder="word.subject"
          />
        </div>

        <div class="mb-3">
          <v-editor
            v-model="formData.body"
            :editor-toolbar="customToolbar"
          />
          <transition-group name="fade-up-fast">
            <div v-for="error in errors.body" :key="error">
              <v-field-error
                :message="error"
              />
            </div>
          </transition-group>
        </div>
        <div class="d-flex justify-content-end">
          <div class="mr-2">
            <v-button
              text="phrase.send_test_mail"
              type="button"
              size="sm"
              style-type="secondary"
              @click="sendTestMail"
            />
          </div>
          <div>
            <v-button
              text="word.send"
              type="button"
              size="sm"
              style-type="primary"
              icon="envelope"
              @click="showConfirmMessageTrue"
              v-if="showConfirmMessage === false"
            />
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <transition name="fade-slow-nl">
          <div v-if="showConfirmMessage" class="pt-2">
            {{ $t('phrase.are_you_sure') }}
            <v-button
              text="word.no"
              type="button"
              size="sm"
              style-type="link"
              @click="showConfirmMessage = false"
            />
            <v-button
              text="word.yes"
              style-type="warning"
              type="button"
              size="sm"
              @click="sendMail"
              :loader="loader"
            />
          </div>
        </transition>
      </div>
    </template>
  </v-modal>
</template>

<script>
import Modal from '@/common/components/Modal.vue';
import Button from '@/common/components/Button.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import { VueEditor } from 'vue2-editor';
import FieldError from '@/common/components/FieldError.vue';
import { mapGetters } from 'vuex';
import { sendMail } from '@/admin/api';
import { notify } from '@/common/utils/notify';

export default {
  name: 'SendMailModal',
  components: {
    'v-modal': Modal,
    'v-button': Button,
    'v-text-input': TextInput,
    'v-editor': VueEditor,
    'v-field-error': FieldError,
  },
  props: {
    userCount: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    async sendTestMail() {
      const errors = this.validateForm();
      if (Object.keys(errors).length > 0) {
        this.errors = errors;
        return;
      }
      this.loader.loading = true;
      const response = await sendMail({
        test_mail: true,
        subject: this.formData.subject,
        body: this.formData.body,
      });

      if (response.status === 200) {
        notify(this.$t('sentence.email_sent'));
      } else {
        notify(this.$t('sentence.email_not_sent'), '', 'error');
      }
    },
    sendMail() {
      this.loader.loading = true;
      this.$emit('send-mail', {
        subject: this.formData.subject,
        body: this.formData.body,
      });
    },
    validateForm() {
      const errors = {};

      if (!this.formData.subject) {
        errors.subject = [this.$t('phrase.field_required')];
      } else {
        errors.subject = [];
      }

      if (!this.formData.body) {
        errors.body = [this.$t('phrase.field_required')];
      } else {
        errors.body = [];
      }

      if (
        Object.values(errors)
          .filter((error) => (error.length > 0)).length > 0
      ) {
        return errors;
      }
      return {};
    },
    showConfirmMessageTrue() {
      const errors = this.validateForm();
      if (Object.keys(errors).length > 0) {
        this.errors = errors;
        return;
      }
      this.showConfirmMessage = true;
    },
  },
  data() {
    return {
      formData: {
        subject: '',
        body: '',
      },
      errors: {},
      showConfirmMessage: false,
      loader: {
        loading: false,
      },
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }],
        ['link', 'image', 'video'],
        ['clean'],
      ],
      editorSettings: {
        modules: {
          imageDrop: true,
        },
      },
    };
  },
};
</script>
